// src/components/Layout/DashboardLayout.js

import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import LeftSidebarMenu from "./LeftSidebarMenu";
import TopNavbar from "./TopNavbar";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const handleToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#FFFFFF",
        ".dark-theme &, [data-theme='dark'] &, .dark &": {
          backgroundColor: "#071524 !important",
        },
      }}
    >
      {/* Dynamic Sidebar Shell */}
      <Box
        sx={{
          width: isSidebarOpen ? "235px" : "0px",
          minWidth: isSidebarOpen ? "235px" : "0px",
          maxWidth: isSidebarOpen ? "235px" : "0px",
          flexShrink: 0,
          height: "100vh",
          overflow: "hidden",
          transition: "width 0.25s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
          zIndex: 1200,
        }}
      >
        <LeftSidebarMenu />
      </Box>

      {/* Main Right Content Area */}
      <Box
        sx={{
          flex: "1 1 auto",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          minWidth: 0,
        }}
      >
        {/* Top Navbar with toggleActive */}
        <Box sx={{ flexShrink: 0, width: "100%", zIndex: 1100 }}>
          <TopNavbar toggleActive={handleToggle} />
        </Box>

        {/* Scrollable Main View */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            overflowX: "hidden",
            px: { xs: 2, md: 3 },
            py: 2,
            boxSizing: "border-box",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;